import { Action } from 'redux';

import { SET_BIN, SET_NAME, SET_SURNAME, RESET_REGISTRATION, RESET_SEND_CODE_REGISTRATION } from '../../actions/Registration/registration';
import { REGISTRATION_CHECK_BIN_REQUEST, REGISTRATION_CHECK_BIN_RESPONSE, REGISTRATION_CHECK_BIN_ERROR } from '../../actions/Registration/registration';
import { REGISTRATION_REQUEST, REGISTRATION_RESPONSE, REGISTRATION_ERROR } from '../../actions/Registration/registration';
import { REGISTRATION_SEND_CODE_REQUEST, REGISTRATION_SEND_CODE_RESPONSE, REGISTRATION_SEND_CODE_ERROR } from '../../actions/Registration/registration';

export interface RegistrationState {
    bin: string;
    name: string;
    surname: string;

    checkBin: boolean;
    loadingCheckBin: boolean;
    errorCheckBin: string | null;

    registration: boolean;
    loadingRegistration: boolean;
    errorRegistration: {
        error: string;
        message: {
            ru: string;
        };
        code: number;
    } | null;

    sendCodeRegistration: boolean;
    loadingSendCodeRegistration: boolean;
    errorSendCodeRegistration: string | {
        error: string;
        message: {
            ru: string;
        };
        code: number;
    } | null;
    isFirebaseAuth: boolean;
}

const initialState: RegistrationState = {
    bin: '',
    name: '',
    surname: '',

    checkBin: false,
    loadingCheckBin: false,
    errorCheckBin: null,

    registration: false,
    loadingRegistration: false,
    errorRegistration: null,

    sendCodeRegistration: false,
    loadingSendCodeRegistration: false,
    errorSendCodeRegistration: null,
    isFirebaseAuth: false
};

export function registrationState(state: RegistrationState = initialState, action: Action) {
    switch (action.type) {
        case RESET_REGISTRATION: {
            return {
                ...state,
                registration: initialState.registration,
                loadingRegistration: initialState.loadingRegistration,
                errorRegistration: initialState.errorRegistration,
            };
        }
        case RESET_SEND_CODE_REGISTRATION: {
            return {
                ...state,
                sendCodeRegistration: initialState.sendCodeRegistration,
                loadingSendCodeRegistration: initialState.loadingSendCodeRegistration,
                errorSendCodeRegistration: initialState.errorSendCodeRegistration,
            };
        }
        case REGISTRATION_CHECK_BIN_REQUEST: {
            return {
                ...state,
                loadingCheckBin: true,
                checkBin: initialState.checkBin,
                errorCheckBin: initialState.errorCheckBin,
            };
        }
        case REGISTRATION_CHECK_BIN_RESPONSE: {
            return {
                ...state,
                loadingCheckBin: false,
                checkBin: true,
            };
        }
        case REGISTRATION_CHECK_BIN_ERROR: {
            const errorCheckBin = (action as any).error.error;
            return {
                ...state,
                loadingCheckBin: false,
                errorCheckBin,
            };
        }
        case REGISTRATION_REQUEST: {
            return {
                ...state,
                registration: initialState.registration,
                loadingRegistration: true,
                errorRegistration: initialState.errorRegistration,
            };
        }
        case REGISTRATION_RESPONSE: {
            const response = (action as any).response;
            return {
                ...state,
                registration: true,
                loadingRegistration: false,
                isFirebaseAuth: !!response.result.is_firebase_auth
            };
        }
        case REGISTRATION_ERROR: {
            const errorRegistration = (action as any).error.error;
            return {
                ...state,
                loadingRegistration: false,
                errorRegistration,
            };
        }
        case REGISTRATION_SEND_CODE_REQUEST: {
            return {
                ...state,
                sendCodeRegistration: initialState.sendCodeRegistration,
                loadingSendCodeRegistration: true,
                errorSendCodeRegistration: initialState.errorSendCodeRegistration,
            };
        }
        case REGISTRATION_SEND_CODE_RESPONSE: {
            const response = (action as any).response;
            localStorage.setItem('auth', JSON.stringify(response.result));
            localStorage.setItem('KON_USER_ID', response.result.token);
            return {
                ...state,
                sendCodeRegistration: true,
                loadingSendCodeRegistration: false,
            };
        }
        case REGISTRATION_SEND_CODE_ERROR: {
            const errorSendCodeRegistration = (action as any).error.error;
            return {
                ...state,
                loadingSendCodeRegistration: false,
                errorSendCodeRegistration,
            };
        }
        case SET_BIN: {
            const bin = (action as any).bin;
            return {
                ...state,
                bin,
            };
        }
        case SET_NAME: {
            const name = (action as any).name;
            return {
                ...state,
                name,
            };
        }
        case SET_SURNAME: {
            const surname = (action as any).surname;
            return {
                ...state,
                surname,
            };
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/reducers/Registration/registration.ts